import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Menu from '@mui/material/Menu'
import Typography from '@mui/material/Typography'
import {KeyboardArrowDown, KeyboardArrowRight} from '@mui/icons-material'
import {Link} from 'react-router-dom'
import {filterCards, debounce} from 'utils/utils'
import {renameCard, fetchModules} from 'modules/modules/actions'
import route from 'utils/enums/route'

const Module = styled(Link)`
	color: #A0B7BE;
	font-size: 16px;
	cursor: pointer;
`

const Container = styled.div`
    display: flex;
    align-items: center;
    margin-right: auto;
`

const Title = styled.div`
    color: #A0B7BE;
    padding: 15px;
    text-transform: uppercase;
    letter-spacing: 2px;
`

const ArrowDown = styled(KeyboardArrowDown)`
    font-size: 22px;
    cursor: pointer;
    align-self: flex-end;
`

const ArrowRight = styled(KeyboardArrowRight)`
    font-size: 22;
    color: #A0B7BE;
`

const Search = styled(TextField)`
	width: auto;
	padding: 10px;
	position: sticky;
	top: 0;
	background: #FFFFFF;
	z-index: 1;
	display: flex;
`

const Label = styled.div`
    position: relative;
	display: flex;
	font-weight: bold;
	font-size: ${props => props.mobile ? '15px' : '20px'};
	margin: ${props => props.mobile ? '0 10px' : 0};
	color: #4a4a4a;

    svg {
        display: block;
    }

    :focus-within {
        svg {
            display: none;
        }
    }
`

const Input = styled.span`
	min-width: 15px;

    + div {
        left: 0;
        right: 0;
        bottom: -5px;
        content: "";
        position: absolute;
        transform: scaleX(0);
        transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
        border-bottom: 2px solid #415dd4;
        pointer-events: none;
    }

    :focus {
        + div {
            transform: scaleX(1);
        }
    }
`

class PageNavigation extends React.Component {
    constructor(props) {
        super(props)

		this.modules = []

        this.state = {
            anchorEl: null,
			pattern: ''
        }
    }

    componentDidMount() {
        this.props.fetchModules()
    }

    handleClick = event => {
		this.modules = [...this.props.modules]
        this.setState({ anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ anchorEl: null, pattern: '' })
    }

	setOrder = (data) => {
		const arr = [...data]
		return arr.sort((a, b) => {
			if (!a.label) return 1
			if (!b.label) return -1
			if (a.label > b.label) return 1
			if (a.label < b.label) return -1
			return 0
		})
	}

	handleChange = debounce((value) => {
		const data = filterCards(value, this.props.modules)
        this.modules = [...data.modules]
        this.setState({ pattern: value })
	}, 300)

	handleBlur = (e) => {
		const {currentCard} = this.getModule()
		const label = currentCard.label

        if (e.target.innerText && e.target.innerText !== label) {
			this.props.renameCard(this.props.id, e.target.innerText, currentCard.type)
        } else {
            this.title.innerText = label
        }
    }

	handleCheckKeyCode = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault()
            this.title.blur()
        }

        if (e.keyCode === 27) {
            this.title.blur()
        }
    }

    getModule = () => {
        const currentModule = this.props.modules.find(item => item.cards.find(card => {
            if (this.props.type === route.Planning) {
                return card.planningId === this.props.id
            } else if (this.props.type === route.Scheduler) {
                return card.schedulerId === this.props.id
            } else {
                return card.listId === this.props.id
            }
        }))

        const currentCard = currentModule && currentModule.cards.find(item => {
            if (this.props.type === route.Planning) {
                return item.planningId === this.props.id
            } else if (this.props.type === route.Scheduler) {
                return item.schedulerId === this.props.id
            } else {
                return item.listId === this.props.id
            }
        })

        return {currentCard, currentModule}
    }

    render() {
		const {mobile, permissions} = this.props
		const {currentCard, currentModule} = this.getModule()

        return (
            <Container>
                {currentModule && !mobile &&
                    <React.Fragment>
                        <Module to={`/module/${currentModule.id}`}>{currentModule.name}</Module>
                        <ArrowRight />
						<Label mobile={mobile}>
							{currentCard.label ?
								<React.Fragment>
									<Input
										ref={el => this.title = el}
										contentEditable={permissions.Designer ? true : false}
										spellCheck={false}
										suppressContentEditableWarning={true}
										onBlur={this.handleBlur}
										onKeyDown={this.handleCheckKeyCode}
									>
										{currentCard.label}
									</Input>
									<div />
								</React.Fragment>
								:
								<div>{this.props.intl.formatMessage({id: "app.unnamed_graphic"})}</div>
							}
							<ArrowDown onClick={this.handleClick} />
						</Label>
                    </React.Fragment>
                }
				{currentModule && mobile &&
                    <Label mobile={mobile}>
						{currentCard.label || this.props.intl.formatMessage({id: "app.unnamed_graphic"})}
					</Label>
                }
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={!!this.state.anchorEl}
                    onClose={this.handleClose}
					variant='menu'
					MenuListProps={{
						style: {
							paddingTop: 0
						}
					}}
                    PaperProps={{
                        style: {
                            maxHeight: '300px',
                            maxWidth: '500px',
							minWidth: '300px'
                        }
                    }}
                >
					{currentCard && !currentCard.planningId && !currentCard.schedulerId &&
						<Search
							variant="standard"
							onChange={(e) => this.handleChange(e.target.value)}
							defaultValue={this.state.pattern}
							onKeyDown={(e) => e.stopPropagation()}
						/>
					}
                    {this.modules.map((item, index) =>
                        <div key={index}>
                            <Title>
                                {item.name}
                            </Title>
                            {this.setOrder(item.cards).map(card => {
                                const path = card.planningId ? '/planning/' + card.planningId + '/month' :
                                    card.schedulerId ? '/scheduler/' + card.schedulerId + '/month' :
									'/list/' + card.listId

                                return <MenuItem
                                    to={path}
                                    component={Link}
                                    key={card.id}
                                    onClick={this.handleClose}
                                    selected={card.planningId ? card.planningId === this.props.id :
                                        card.schedulerId ? card.schedulerId === this.props.id :
										card.listId === this.props.id}
                                >
                                    <span className={"entity-icon-medium entity-icon-" + (card.icon || 'graphiccard')} />
                                    <Typography variant='inherit' noWrap>
                                        {card.label || this.props.intl.formatMessage({id: "app.unnamed_graphic"})}
                                    </Typography>
                                </MenuItem>
                            })}
                        </div>
                    )}
                </Menu>
            </Container>
        )
    }
}

const mapStateToProps = ({modules}) => ({
    modules: modules.modules
})

export default connect(mapStateToProps, {renameCard, fetchModules})(injectIntl(PageNavigation))
